const DEBUG_FLAGS = {
  NO_LOCALSTORAGE: false,
  SIMULATE_STORAGE_ERROR: false,
  SHOW_MAP_CENTER: false,
};

export default DEBUG_FLAGS;
